import React, { useEffect, useState } from "react";
import { Button, Typography } from "@material-ui/core";
import TitleContainer from "~/components/common/titleContainer/TitleContainer";
import WarningIcon from "@material-ui/icons/Warning";
import { useTranslation } from "react-i18next";
import i18n from "~/i18n";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";

const ExpiredLink = () => {
	const location = useLocation();
	const newLink = location.state?.newLink;

	const { t } = useTranslation();

	const [isMounted, setIsMounted] = useState(false);
	const [copied, setCopied] = useState(false);

	useEffect(() => {
		if (!newLink) {
			const locale = navigator.language || navigator.userLanguage || "";
			const lang = locale.toLowerCase().startsWith("pt")
				? "pt-BR"
				: locale.toLowerCase().startsWith("es")
				? "es-ES"
				: "en-US";

			if (lang) i18n.changeLanguage(lang);
		}
		const id = setTimeout(() => setIsMounted(true), 0);
		return () => clearTimeout(id);
	}, []);

	const handleCopyLink = async () => {
		if (!newLink) return;
		try {
			if (navigator.clipboard && navigator.clipboard.writeText) {
				await navigator.clipboard.writeText(newLink);
			} else {
				const temp = document.createElement("textarea");
				temp.value = newLink;
				document.body.appendChild(temp);
				temp.select();
				document.execCommand("copy");
				document.body.removeChild(temp);
			}
			setCopied(true);
			setTimeout(() => setCopied(false), 1600);
		} catch (e) {
			// no-op; silent fail to avoid UX interruption
		}
	};

	const handleGoToSuport = () => {
		const raw = [t("supportExpiredLinkMessage")].join("\n");

		const message = encodeURIComponent(raw);

		const link = `https://wa.me/?text=${message}`;
		window.open(link, "_blank");
	};

	const baseFadeUpStyle = isMounted
		? { opacity: 1, transform: "translateY(0)" }
		: { opacity: 0, transform: "translateY(12px)" };

	const content = (
		<div
			style={{
				display: "flex",
				flexDirection: "column",
				alignItems: "center",
				gap: 16,
				padding: 16,
				transition: "opacity 300ms ease, transform 300ms ease",
				...baseFadeUpStyle,
			}}>
			<WarningIcon style={{ color: "#F1C40F", fontSize: 48 }} />
			<Typography variant="h5" style={{ fontWeight: 700, textAlign: "center" }}>
				{t("Expired link")}
			</Typography>
			<Typography variant="body2" style={{ textAlign: "center", color: "#333" }}>
				{t("This link has been replaced to provide a safer updated experience")}
			</Typography>
			{!newLink && (
				<>
					<Typography variant="body2" style={{ textAlign: "center", color: "#333" }}>
						{t("Please ask the business directly for a new link to continue with your booking")}
					</Typography>
					<div style={{ width: "100%", maxWidth: 420, marginTop: 8 }}>
						<Button
							onClick={handleGoToSuport}
							fullWidth
							variant="contained"
							style={{ backgroundColor: "#27AE60", color: "#fff" }}>
							{t("Talk to the business")}
						</Button>
					</div>
				</>
			)}
			{newLink && (
				<>
					<div
						style={{
							width: "calc(100% - 32px)",
							maxWidth: 520,
							backgroundColor: "#FFF8E1",
							border: "1px solid #FFE082",
							color: "#5D4037",
							borderRadius: 8,
							padding: 16,
							display: "flex",
							alignItems: "flex-start",
							flexWrap: "wrap",
							margin: "0 16px",
							boxSizing: "border-box",
							transition: "opacity 360ms ease, transform 360ms ease",
							transitionDelay: isMounted ? "120ms" : "0ms",
							...(isMounted
								? { opacity: 1, transform: "translateY(0)" }
								: { opacity: 0, transform: "translateY(10px)" }),
						}}>
						<WarningIcon style={{ color: "#F1C40F" }} />
						<div
							style={{
								display: "flex",
								flexDirection: "column",
								gap: 8,
								flex: 1,
								minWidth: 0,
								wordBreak: "break-word",
							}}>
							<Typography variant="subtitle1" style={{ fontWeight: 700 }}>
								{t("The old link has expired")}
							</Typography>
							<Typography variant="body2" style={{ lineHeight: 1.4 }}>
								{newLink
									? t("Use the new link below to continue your booking")
									: t("Please ask the business directly for a new link to continue with your booking")}
							</Typography>
							{newLink && (
								<div
									style={{
										display: "flex",
										flexDirection: "column",
										gap: 8,
										alignItems: "center",
										marginTop: 4,
										justifyContent: "center",
										width: "100%",
									}}>
									<div
										style={{
											display: "flex",
											gap: 8,
											width: "100%",
											alignItems: "center",
											justifyContent: "center",
											flexDirection: "column",
										}}>
										<Button
											variant="contained"
											color="primary"
											onClick={handleCopyLink}
											style={{ textTransform: "none", whiteSpace: "nowrap" }}>
											{copied ? t("Copied") : t("Copy Link")}
										</Button>
										<Typography
											variant="caption"
											style={{
												background: "#FFF",
												border: "1px solid #EEE",
												borderRadius: 4,
												padding: "6px 8px",
												maxWidth: "100%",
												overflow: "hidden",
												textOverflow: "ellipsis",
												whiteSpace: "nowrap",
												flex: 1,
												display: "block",
											}}
											title={newLink}>
											{newLink}
										</Typography>
									</div>
								</div>
							)}
						</div>
					</div>
				</>
			)}
		</div>
	);

	return (
		<TitleContainer imageVisible={false} backgroundNew={false} showGradient={false}>
			{content}
		</TitleContainer>
	);
};

export default ExpiredLink;
